var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    { attrs: { layout: "inline" } },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 8, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "所属门店",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: { placeholder: "请选择门店" },
                                      on: { change: _vm.onStoreChange },
                                      model: {
                                        value: _vm.storeId,
                                        callback: function ($$v) {
                                          _vm.storeId = $$v
                                        },
                                        expression: "storeId",
                                      },
                                    },
                                    _vm._l(_vm.storeOptionList, function (s) {
                                      return _c(
                                        "a-select-option",
                                        { key: s.id, attrs: { value: s.id } },
                                        [_vm._v(_vm._s(s.name))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "section-title" }, [_vm._v("公告管理")]),
              _c(
                "div",
                { staticClass: "table-operator" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", icon: "plus" },
                      on: { click: _vm.handleAdd },
                    },
                    [_vm._v("新增公告")]
                  ),
                ],
                1
              ),
              _c("a-table", {
                ref: "table",
                attrs: {
                  size: "middle",
                  bordered: "",
                  rowKey: "id",
                  columns: _vm.columns,
                  dataSource: _vm.dataSource,
                  pagination: _vm.ipagination,
                  loading: _vm.loading,
                },
                on: { change: _vm.handleTableChange },
                scopedSlots: _vm._u([
                  {
                    key: "typeSlot",
                    fn: function (text, record) {
                      return [
                        String(record.noticeType) === "1"
                          ? _c("a-tag", { attrs: { color: "green" } }, [
                              _vm._v("前台公告"),
                            ])
                          : _c("a-tag", { attrs: { color: "orange" } }, [
                              _vm._v("后台公告"),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "displaySlot",
                    fn: function (text, record) {
                      return [
                        _c("a-switch", {
                          attrs: {
                            checked: String(record.display) === "1",
                            checkedChildren: "显示",
                            unCheckedChildren: "隐藏",
                          },
                          on: {
                            change: (checked) =>
                              _vm.onDisplayChange(record, checked),
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "action",
                    fn: function (text, record) {
                      return _c(
                        "span",
                        {},
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.handleEdit(record)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _c("a-divider", { attrs: { type: "vertical" } }),
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(record)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ],
                        1
                      )
                    },
                  },
                ]),
              }),
              _c(
                "a-modal",
                {
                  staticStyle: { top: "120px" },
                  attrs: {
                    title: _vm.dialogTitle,
                    width: 700,
                    visible: _vm.dialogVisible,
                    confirmLoading: _vm.confirmLoading,
                    maskClosable: false,
                    cancelText: "取 消",
                    okText: "确 定",
                  },
                  on: {
                    ok: _vm.handleModalOk,
                    cancel: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [
                  _c(
                    "a-form",
                    { staticClass: "notice-form" },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "排序",
                            labelCol: { span: 4 },
                            wrapperCol: { span: 18 },
                          },
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              type: "number",
                              placeholder: "请输入排序",
                            },
                            model: {
                              value: _vm.noticeForm.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.noticeForm, "sort", $$v)
                              },
                              expression: "noticeForm.sort",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "公告类型",
                            labelCol: { span: 4 },
                            wrapperCol: { span: 18 },
                            required: "",
                          },
                        },
                        [
                          _c(
                            "a-radio-group",
                            {
                              model: {
                                value: _vm.noticeForm.noticeType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.noticeForm, "noticeType", $$v)
                                },
                                expression: "noticeForm.noticeType",
                              },
                            },
                            [
                              _c("a-radio", { attrs: { value: "1" } }, [
                                _vm._v("前台公告"),
                              ]),
                              _c("a-radio", { attrs: { value: "2" } }, [
                                _vm._v("后台公告"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "公告标题",
                            labelCol: { span: 4 },
                            wrapperCol: { span: 18 },
                            required: "",
                          },
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "460px" },
                            attrs: {
                              autocomplete: "off",
                              placeholder: "请输入公告标题",
                            },
                            model: {
                              value: _vm.noticeForm.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.noticeForm, "title", $$v)
                              },
                              expression: "noticeForm.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "公告简介",
                            labelCol: { span: 4 },
                            wrapperCol: { span: 18 },
                          },
                        },
                        [
                          _c("a-textarea", {
                            attrs: { placeholder: "请输入公告简介", rows: 2 },
                            model: {
                              value: _vm.noticeForm.introduction,
                              callback: function ($$v) {
                                _vm.$set(_vm.noticeForm, "introduction", $$v)
                              },
                              expression: "noticeForm.introduction",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "公告详情",
                            labelCol: { span: 4 },
                            wrapperCol: { span: 18 },
                          },
                        },
                        [
                          _c("a-textarea", {
                            attrs: { placeholder: "请输入公告详情", rows: 6 },
                            model: {
                              value: _vm.noticeForm.body,
                              callback: function ($$v) {
                                _vm.$set(_vm.noticeForm, "body", $$v)
                              },
                              expression: "noticeForm.body",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "显示状态",
                            labelCol: { span: 4 },
                            wrapperCol: { span: 18 },
                          },
                        },
                        [
                          _c("a-switch", {
                            attrs: {
                              checked: String(_vm.noticeForm.display) === "1",
                              checkedChildren: "显示",
                              unCheckedChildren: "隐藏",
                            },
                            on: {
                              change: (checked) =>
                                _vm.onFormDisplayChange(checked),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }